<template>
<div class='welcome-card pane'>
  <div class='features'>
    <div class='feature'>
      <div class='img light' />
      <p class='title'>最简单的 H5 工具</p>
      <div class='sub'>
        <p>一键 PPT 转换 H5，零门槛上手</p>
        <p>完美还原动画、音视频、交互</p>
      </div>
    </div>

    <div class='feature'>
      <div class='img doc' />
      <p class='title'>支持答题 & 录音</p>
      <div class='sub'>
        <p>所见即所得制作答题、表单及录音</p>
        <p>轻松搞定专业级功能</p>
      </div>
    </div>

    <div class='feature' v-if="tbcMode">
      <div class='img desk' />
      <p class='title'>一键上传，碎片知识快速沉淀</p>
      <div class='sub'>
        <p>支持将制作好的微课一键同步上传至课程和资料</p>
        <p>快速沉淀业务碎片化知识，搭建内部微课体系</p>
      </div>
    </div>

    <div class='feature' v-else>
      <div class='img wechat' />
      <p class='title'>扫码阅读，轻松分享传播</p>
      <div class='sub'>
        <p>微信扫码查看 H5，随心分享</p>
        <p>营销策划、微课、产品介绍、工作汇报，统统搞定</p>
      </div>
    </div>
  </div>

  <div class='btn'>
    <el-button type='primary' @click="$emit('click')" v-if="showCreateProject">开始上传</el-button>
    <span v-else>{{$t('noProject')}}</span>
  </div>
</div>
</template>

<i18n>
{
  "zh-cn": {
    "noProject": "暂无@:common.project"
  }
}
</i18n>

<script>
export default {
  computed: {
    showCreateProject() {
      return !this.organization || this.canDo('create_project')
    }
  }
}
</script>

<style lang='scss' scoped>
.welcome-card {
    height: 500px;

    .features {
        width: $page-width-small;
        margin: 80px auto;
        overflow: hidden;

        .feature {
            width: 33%;
            float: left;
            text-align: center;

            .img {
                width: 100px;
                height: 100px;
                background-size: contain;
                background-repeat: no-repeat;

                &.light {
                    background-image: url("_images/light.png");
                }
                &.doc {
                    background-position: 0 29px;
                    background-image: url("_images/doc.png");
                }
                &.wechat {
                    background-image: url("_images/wechat.png");
                }
                &.desk {
                    background-image: url("_images/desk.png");
                    background-position: bottom;
                }
            }

            .title {
                color: $font-color-strong;
                font-size: 18px;
                font-weight: bold;
                margin: 2em 0;
            }

            .sub {
                white-space: nowrap;
                color: $font-color-strong;
                p {
                    margin: 0.4em;
                }
            }
        }
    }

    .btn {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// welcome.vue?bf5db090